import React from 'react';
import styled from "styled-components";

const ItemOuter = styled.div `
  position: relative;
  display:flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
`;


const ItemHeading = styled.div `
    a.active  {
        color: ${({content}) => content.highlightColor};
    }
    a { color: ${({content}) => content.titleTextColor};}
    
`;

export default function Login ({link, styles}) {
  
  if (link) {
    return (
      <ItemOuter>
        <ItemHeading content={styles}>
          <a href={link} rel='nofollow' >Login</a>
        </ItemHeading>
      </ItemOuter>
    )}
  return null;
};
